import PawModel from './PawModel';

class ViewFolder extends PawModel {
  filter: any;

  title?: string;

  parent_id?: string;

  level?: number;

  values?: any;
}

export default ViewFolder;
